import { render, staticRenderFns } from "./time.vue?vue&type=template&id=c56a2544&scoped=true"
import script from "./time.vue?vue&type=script&lang=js"
export * from "./time.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c56a2544",
  null
  
)

export default component.exports